import {RemotePostPreviewsProcedure} from 'data/usecases/private/refund/request-preview';
import {PostPreviewsProcedure} from 'domain/usecases/private/refund/request-preview';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePostPreviewsProcedure = (): PostPreviewsProcedure =>
	new RemotePostPreviewsProcedure(
		makeBFFApiUrl(RefundFlowEndPoints.previewsProcedure),
		makeAuthorizeHttpClientDecorator(),
	);
